import { Component, createSignal, Show } from "solid-js";
import { A } from "./universal/a-href";
import { Img } from "./universal/image";
import { fetchGet } from "../library/common";

export type Notification = {
    id: number;
    backgroundColour: string;
    visible: boolean;
    read: boolean;
    imageUrl: string;
    url: string;
    text: string;
    
};
export type NotificationRenderProps = {
    data: Notification;
};  

export const NotificationRender : Component<NotificationRenderProps> = (props) => {
    const [show, setShow] = createSignal<boolean>(props.data.visible);
    const [read, setRead] = createSignal<boolean>(props.data.read);
    const hideClicked = (e: Event) => {
        e.preventDefault();
        setShow(false);
    };
    const markReadClicked = async (e: Event) => {
        e.preventDefault();
        const response = await fetchGet("/Notification/MarkReadJson", { id: props.data.id });
        const json = await response.json();
        if (!json.Success) return;
        setRead(true);
    };
    return (
        <Show when={show()}>
            <div class="notifications__results__notification-row" style={{ "background-color": props.data.backgroundColour }}>
                <div class="notifications__results__notification-row__hide-link-row">
                    <a onClick={hideClicked} style="color: #000; font-size: 0.8em;">Hide</a>
                </div>
                <Show when={!read()}>
                    <div class="notifications__results__notification-row__mark-read-link-row">
                        <a onClick={markReadClicked} style="color: #000; font-size: 0.8em;">Mark Read</a>
                    </div>
                </Show>
                <div class="notifications__results__notification-row__image">
                    <Show when={!!props.data.imageUrl}>
                        <Img
                            src={props.data.imageUrl}
                            mode="crop" w="50" h="50" style="width: 50px; height: 50px;"
                        />
                    </Show>
                    <Show when={!props.data.imageUrl}>
                        <div style="width: 50px; height: 50px; min-width: 50px;"></div>
                    </Show>
                </div>
                <div class="notifications__results__notification-row__content">
                    <p class="notifications__results__notification-row__content__text">
                        <A style="color: #000;" href={props.data.url}>
                            {props.data.text}
                        </A>
                    </p>
                    <p class="notifications__results__notification-row__content__date-added">
                        <span style="margin-right: 5px;" data-bind="css: $data.iconClass"></span>
                        <span data-bind="visible: $data.notifiedToday">about <span data-bind="text: $data.hoursAgo"></span> hours ago</span>
                        <span data-bind="visible: !$data.notifiedToday()"><span data-bind="text: $data.daysAgo"></span> days ago</span>
                    </p>
                </div>
            </div>
        </Show>
    );
}